import React from "react";
import Assess from "../assets/images/logo/assess.png";
import Fidelity from "../assets/images/logo/fidelity.png";
import Tek from "../assets/images/logo/tek.png";
import Stova from "../assets/images/logo/stova.png";
import NowNow from "../assets/images/logo/nownow.png";
import Spectranet from "../assets/images/logo/spectranet.png";
import Oriflame from "../assets/images/oriflame.png";
import Binatone from "../assets/images/logo/binatone.png";
import Pladis from "../assets/images/logo/pladis.png";
import Coffee from "../assets/images/logo/codd.png";
import Indomie from "../assets/images/logo/indomie.webp"
import ARM from "../assets/images/logo/arm.png"
import GreenLoto from "../assets/images/logo/greenloto.png"
import MayFlower from "../assets/images/logo/mayflower.png"
import Quant from "../assets/images/logo/quant.png"
import Quinox from "../assets/images/logo/quinox.png";
import Vendease from "../assets/images/logo/Vendease.webp"
import TownCriers from "../assets/images/logo/tc.png"
import Nestle from "../assets/images/logo/nestle.webp"
import TopKlan from "../assets/images/logo/topklan.png"
import Lavideepu from "../assets/images/logo/lavideepu.jpg"
import ASB from "../assets/images/logo/asb.png"
import FlowInk from "../assets/images/logo/flowink.png"
import Aava from "../assets/images/logo/aava.png"
import MBH from "../assets/images/logo/mbh.png"
import Solutions from "../assets/images/logo/todayssolution.png"




// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

// Import Swiper styles
import "swiper/css";

const Client = () => {


  const company = [
    {
      id: 6,
      path: Fidelity,
    },
    {
      id: 1,
      path: NowNow,
    },
    {
      id: 2,
      path: Stova,
    },
    {
      id: 3,
      path: Tek,
    },
    {
      id: 4,
      path: Spectranet,
    },
    {
      id: 5,
      path: Assess,
    },
    {
      id: 7,
      path: Oriflame,
    },
    {
      id: 8,
      path: Binatone,
    },
    {
      id: 9,
      path: Pladis,
    },
    {
      id: 10,
      path: Coffee,
    },
    {
      id: 11,
      path: Indomie,
    },
    {
      id: 12,
      path: ARM,
    },
    {
      id: 13,
      path: GreenLoto,
    },
    {
      id: 14,
      path: MayFlower,
    },
    {
      id: 15,
      path: Quant,
    },
    {
      id: 16,
      path: Quinox,
    },
    {
      id: 17,
      path: Vendease,
    },
    {
      id: 18,
      path: TownCriers,
    },
    {
      id: 19,
      path: Nestle,
    },
    {
      id: 20,
      path: TopKlan,
    },
    {
      id: 21,
      path: Lavideepu,
    },
    {
      id: 22,
      path: ASB,
    },
    {
      id: 23,
      path: FlowInk,
    },
    {
      id: 24,
      path: Aava,
    },
    {
      id: 25,
      path: Solutions,
    },
    {
      id: 26,
      path: MBH,
    },
  ];

  return (
    <>
      <div className="container mx-auto px-4">
        <div className="my-10">
          <p className="text-2xl md:text-4xl font-semibold text-darkBlue text-opacity-75">
            Clients
          </p>
        </div>
        <div className="flex justify-center">
          {" "}
          <Swiper
            modules={[Autoplay]}
            spaceBetween={50}
            slidesPerView={4}
            loop={true}
            // onSlideChange={() => console.log("slide change")}
            // onSwiper={(swiper) => console.log(swiper)}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
          >
            {company.map((company) => (
              <SwiperSlide className="flex items-center">
                <img
                  src={company.path}
                  alt=""
                  className="w-28 h-14 mx-auto items-center object-contain"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>


    </>
  );
};

export default Client;



